<template>
  <template v-if="!isShowGeneralFilter">
    <div v-show="!formShow.open">
      <a-space>
        <a-button
          type="link"
          @click="handleShowGeneralFilter"
          v-if="is_show_advantage"
        >
          {{ $t('高级') }}
        </a-button>
        <a-button
          type="link"
          @click="
            () => {
              formShow.open = true;
              $emit('resize');
            }
          "
        >
          {{ $t('展开') }}
        </a-button>
      </a-space>
      <span v-for="field in form.fields">
        <span v-if="field.type == 'rangepicker'">
          <a-tag
            v-show="model[field.name] != null && model[field.name] != ''"
            color="green"
          >
            <a-button
              size="small"
              type="text"
              @click="reduceRangePre(field)"
            >
              <template #icon><left-outlined /></template>
            </a-button>
            <a-button
              size="small"
              type="text"
              @click="addRangePre(field)"
            >
              <template #icon><right-outlined /></template>
            </a-button>
            {{ field.label }}:{{ showLabel(field, field.name) }}
            <a-button
              size="small"
              type="text"
              @click="reduceRangeAfter(field)"
            >
              <template #icon><left-outlined /></template>
            </a-button>
            <a-button
              size="small"
              type="text"
              @click="addRangeAfter(field)"
            >
              <template #icon><right-outlined /></template>
            </a-button>
            <close-outlined
              style="cursor: pointer; margin-left: 5px"
              @click="delSearch({ name: field.name, key: 'model' })"
            />
          </a-tag>
        </span>
        <span v-else-if="field.type == 'datepicker'">
          <a-tag
            v-show="model[field.name] != null && model[field.name] != ''"
            color="green"
          >
            <a-button
              size="small"
              type="text"
              @click="reduce(field)"
            >
              <template #icon><left-outlined /></template>
            </a-button>
            {{ field.label }}:{{ showLabel(field, field.name) }}
            <a-button
              size="small"
              type="text"
              @click="add(field)"
            >
              <template #icon><right-outlined /></template>
            </a-button>
            <close-outlined
              style="cursor: pointer; margin-left: 5px"
              @click="delSearch({ name: field.name, key: 'model' })"
            />
          </a-tag>
        </span>
        <span v-else>
          <a-tag
            v-show="model[field.name] != null && model[field.name] != '' && isShowFilter(field)"
            color="green"
          >
            {{ field.label }}:{{ showLabel(field, field.name) }}
            <close-outlined
              style="cursor: pointer; margin-left: 5px"
              @click="delSearch({ name: field.name, key: 'model' })"
            />
          </a-tag>
        </span>
      </span>
      <template v-if="searchLabelList.length > 0">
        <template
          v-for="(label, index) in searchLabelList"
          :key="index"
        >
          <a-tag
            v-show="
              label.filters
                ? label.filteredValue && JSON.stringify(label.filteredValue) !== '[]'
                : false
            "
            color="green"
          >
            {{ label.label }} 包含：{{ loadLabelOptions(label) }}
            <close-outlined
              style="cursor: pointer; margin-left: 5px"
              @click="delSearch({ label, key: 'filters' })"
            />
          </a-tag>
        </template>
        <template
          v-for="(label, index) in searchLabelList"
          :key="index"
        >
          <a-tag
            v-show="label.sorter && label.sortOrder"
            color="blue"
          >
            {{ label.label }}: {{ loadLabelSort(label) }}
            <close-outlined
              style="cursor: pointer; margin-left: 5px"
              @click="delSearch({ label, key: 'sorter' })"
            />
          </a-tag>
        </template>
      </template>
    </div>
    <a-form
      v-if="delayShow || formShow.open"
      v-show="formShow.open"
      ref="form"
      autocomplete="off"
      :model="model"
      :rules="form.rules"
      :layout="form.settings.layout"
      :label-col="form.settings.labelCol"
      :wrapper-col="form.settings.wrapperCol"
      :labelAlign="form.settings.labelAlign"
      scrollToFirstError
    >
      <a-form-item v-if="showSearch">
        <a-space>
          <a-button
            type="link"
            @click="handleShowGeneralFilter"
            v-if="is_show_advantage"
          >
            {{ $t('高级') }}
          </a-button>
          <a-button
            type="link"
            @click="
              () => {
                formShow.open = false;
                $emit('resize');
              }
            "
          >
            {{ $t('隐藏') }}
          </a-button>
        </a-space>
      </a-form-item>
      <template
        v-for="field in form.fields"
        :key="field.name"
      >
        <field-render-2
          v-if="field.type == 'rangepicker'"
          v-model:label="labelModel[field.name]"
          v-model:value="model[field.name]"
          :field="{ ...field, format: field.dateFormat }"
          :formModel="model"
          :options="options[field.datasource ? field.datasource : field.name]"
          :validateInfos="validateInfos"
        />
        <field-render-2
          v-else
          v-model:label="labelModel[field.name]"
          v-model:value="model[field.name]"
          :field="field"
          :formModel="model"
          :options="options[field.datasource ? field.datasource : field.name]"
          :validateInfos="validateInfos"
        />
      </template>
      <a-form-item v-if="showSearch">
        <a-button
          size="small"
          type="primary"
          @click="search"
        >
          {{ $t('查询') }}
        </a-button>
      </a-form-item>
      <a-form-item v-if="showReset">
        <a-button
          size="small"
          @click="resetFields"
        >
          {{ $t('重置') }}
        </a-button>
      </a-form-item>
      <a-form-item v-if="showReport">
        <a-button
          size="small"
          type="info"
          @click="editModal.open = true"
        >
          {{ $t('订阅') }}
        </a-button>
      </a-form-item>
    </a-form>
    <a-modal
      v-if="editModal.open"
      :open="editModal.open"
      @cancel="
        () => {
          editModal.open = false;
        }
      "
    />
  </template>
  <template v-if="isShowGeneralFilter">
    <slot name="generalFilter"></slot>
  </template>
</template>
<script language="ts">
import { watch } from 'vue';
import { CloseOutlined, LeftOutlined, RightOutlined } from '@ant-design/icons-vue';
import moment from 'moment';
import FieldRender2 from 'liyu-pc-base/components/FormRender/FieldRender2.vue';
import { cloneDeep } from 'lodash';

export default {
  name: 'SearchRender',
  components: { FieldRender2, LeftOutlined, RightOutlined, CloseOutlined },
  emits: ['search', 'resize', 'delSearch', 'showGeneralFilter'],
  props: {
    model: {
      type: Object,
      required: true,
    },
    form: {
      type: Object,
      required: true,
    },
    options: {
      type: Object,
      required: true,
    },
    validateInfos: {
      type: Object,
      default: () => {},
    },
    resetFields: {
      type: Function,
      default: () => {},
    },
    showReport: {
      type: Boolean,
      default: () => false,
    },
    showSearch: {
      type: Boolean,
      default: () => true,
    },
    showReset: {
      type: Boolean,
      default: () => true,
    },
    defaultShowEdit: {
      type: Boolean,
      default: () => false,
    },
    search_visible: {
      type: Boolean,
      default: () => false,
    },
    searchLabelList: {
      type: Array,
      default: () => [],
    },
    isShowGeneralFilter: {
      type: Boolean,
      default: () => false,
    },
    is_show_advantage: {
      type: Boolean,
      default: () => false,
    },
    delayShow: {
      type: Boolean,
      default: () => true,
    },
  },
  data() {
    return {
      editModal: {
        open: false,
      },
      formShow: {
        open: this.defaultShowEdit,
      },
      labelModel: {},
    };
  },
  methods: {
    delSearch(obj) {
      this.$emit('delSearch', obj);
    },
    search() {
      this.$refs.form.validate().then(
        () => {
          this.$emit('search');
          this.formShow.open = this.search_visible;
        },
        () => {
          // this.$emit('search');
        },
      );
    },
    validate() {
      return this.$refs.form.validate();
    },
    reset() {
      this.$refs.form.resetFields();
    },
    disable(name) {
      this.form.fields[name].disabled = true;
    },
    disableAll() {
      this.form.fields.forEach(item => {
        item.disabled = true;
      });
    },
    isShowFilter(field) {
      let is = true;
      this.searchLabelList.forEach(item => {
        if (field.name == item.key && item.is_filter_model) {
          is = false;
        }
      });
      return is;
    },
    showLabel(field, name) {
      const options = this.options[field.datasource ? field.datasource : field.name];
      if (this.labelModel[name] != undefined) {
        return this.labelModel[name];
      } else if (options) {
        if (
          typeof this.model[name] == 'object' &&
          this.model[name] != undefined &&
          this.model[name].length >= 0
        ) {
          const selectItems = options
            .filter(item => this.model[name].includes(item.value))
            .map(item => item.name);
          if (selectItems.length > 0) {
            return selectItems;
          }

          return '';
        } else {
          const selectItem = options.find(item => item.value == this.model[name]);
          if (selectItem) {
            return selectItem.name;
          }
          return '';
        }
      } else if (field.type === 'rangepicker' && this.model[name] instanceof Array) {
        const [first, second] = this.model[name];
        let first_srt, second_srt;
        if (field?.picker === 'month') {
          first_srt = moment(first).format('YYYY-MM');
          second_srt = moment(second).format('YYYY-MM');
        } else if (field?.picker === 'year') {
          first_srt = moment(first).format('YYYY');
          second_srt = moment(second).format('YYYY');
        } else if (field?.picker === 'time') {
          first_srt = moment(first, field.valueFormat).format(field.valueFormat);
          second_srt = moment(second, field.valueFormat).format(field.valueFormat);
        } else if (!field?.picker || field?.picker === 'date') {
          if (field.show_time) {
            first_srt = moment(first).format('YYYY-MM-DD HH:mm:ss');
            second_srt = moment(second).format('YYYY-MM-DD HH:mm:ss');
          } else {
            first_srt = moment(first).format('YYYY-MM-DD');
            second_srt = moment(second).format('YYYY-MM-DD');
          }
        } else if (field.valueFormat) {
          first_srt = moment(first).format(field.valueFormat);
          second_srt = moment(second).format(field.valueFormat);
        }
        return `${first_srt},${second_srt}`;
      } else {
        return this.model[name];
      }
    },
    loadLabelOptions(label) {
      if (label?.filters && label.filteredValue) {
        const str = [];
        label.filters.forEach(item => {
          let i = cloneDeep(item.value);
          if (i === 'true') {
            i = true;
          } else if (i === 'false') {
            i = false;
          }
          if (Array.isArray(label.filteredValue)) {
            if (label.filteredValue.includes(i) || label.filteredValue.includes(item.value)) {
              str.push(item.text ? item.text : item.label ? item.label : '');
            }
          } else {
            if (label.filteredValue == i || label.filteredValue == item.value) {
              str.push(item.text ? item.text : item.label ? item.label : '');
            }
          }
        });
        return `" ${str.toString()} "`;
      }
    },
    loadLabelSort(label) {
      if (label?.sorter && label.sortOrder) {
        if (label.sortOrder === 'ascend') {
          return '升序';
        } else if (label.sortOrder === 'descend') {
          return '降序';
        }
      }
    },
    add(fields) {
      if (this.model[fields.name]) {
        if (!fields.picker || fields.picker === 'date') {
          this.model[fields.name] = moment(this.model[fields.name])
            .add('1', 'days')
            .format(fields.valueFormat ? fields.valueFormat : 'YYYY-MM-DD');
          this.search();
        } else if (fields.picker === 'month') {
          this.model[fields.name] = moment(this.model[fields.name])
            .add('1', 'months')
            .format(fields.valueFormat ? fields.valueFormat : 'YYYY-MM');
          this.search();
        } else if (fields.picker === 'week') {
          this.model[fields.name] = moment(this.model[fields.name])
            .add('1', 'weeks')
            .format(fields.valueFormat ? fields.valueFormat : 'GGGG-WW[周]');
          this.search();
        } else if (fields.picker === 'quarter') {
          this.model[fields.name] = moment(this.model[fields.name])
            .add('1', 'quarters')
            .format(fields.valueFormat ? fields.valueFormat : '');
          this.search();
        } else if (fields.picker === 'year') {
          this.model[fields.name] = moment(this.model[fields.name])
            .add('1', 'years')
            .format(fields.valueFormat ? fields.valueFormat : 'YYYY');
          this.search();
        }
      }
    },
    reduce(fields) {
      if (this.model[fields.name]) {
        if (!fields.picker || fields.picker === 'date') {
          this.model[fields.name] = moment(this.model[fields.name])
            .subtract('1', 'days')
            .format(fields.valueFormat ? fields.valueFormat : 'YYYY-MM-DD');
          this.search();
        } else if (fields.picker === 'month') {
          this.model[fields.name] = moment(this.model[fields.name])
            .subtract('1', 'months')
            .format(fields.valueFormat ? fields.valueFormat : 'YYYY-MM');
          this.search();
        } else if (fields.picker === 'week') {
          this.model[fields.name] = moment(this.model[fields.name])
            .subtract('1', 'weeks')
            .format(fields.valueFormat ? fields.valueFormat : 'GGGG-WW[周]');
          this.search();
        } else if (fields.picker === 'quarter') {
          this.model[fields.name] = moment(this.model[fields.name])
            .subtract('1', 'quarters')
            .format(fields.valueFormat ? fields.valueFormat : '');
          this.search();
        } else if (fields.picker === 'year') {
          this.model[fields.name] = moment(this.model[fields.name])
            .subtract('1', 'years')
            .format(fields.valueFormat ? fields.valueFormat : 'YYYY');
          this.search();
        }
      }
    },
    reduceRangePre(fields) {
      console.log('reduceRangePre');
      if (this.model[fields.name]) {
        if (!fields.picker || fields.picker === 'date') {
          this.model[fields.name][0] = moment(this.model[fields.name][0])
            .subtract('1', 'days')
            .format(fields.valueFormat ? fields.valueFormat : 'YYYY-MM-DD');
          this.search();
        } else if (fields.picker === 'month') {
          this.model[fields.name][0] = moment(this.model[fields.name][0])
            .subtract('1', 'months')
            .format(fields.valueFormat ? fields.valueFormat : 'YYYY-MM');
          this.search();
        } else if (fields.picker === 'week') {
          this.model[fields.name][0] = moment(this.model[fields.name][0])
            .subtract('1', 'weeks')
            .format(fields.valueFormat ? fields.valueFormat : 'GGGG-WW[周]');
          this.search();
        } else if (fields.picker === 'quarter') {
          this.model[fields.name][0] = moment(this.model[fields.name][0])
            .subtract('1', 'quarters')
            .format(fields.valueFormat ? fields.valueFormat : '');
          this.search();
        } else if (fields.picker === 'year') {
          this.model[fields.name][0] = moment(this.model[fields.name][0])
            .subtract('1', 'years')
            .format(fields.valueFormat ? fields.valueFormat : 'YYYY');
          this.search();
        }
      }
    },
    addRangePre(fields) {
      if (this.model[fields.name]) {
        if (!fields.picker || fields.picker === 'date') {
          this.model[fields.name][0] = moment(this.model[fields.name][0])
            .add('1', 'days')
            .format(fields.valueFormat ? fields.valueFormat : 'YYYY-MM-DD');
          this.search();
        } else if (fields.picker === 'month') {
          this.model[fields.name][0] = moment(this.model[fields.name][0])
            .add('1', 'months')
            .format(fields.valueFormat ? fields.valueFormat : 'YYYY-MM');
          this.search();
        } else if (fields.picker === 'week') {
          this.model[fields.name][0] = moment(this.model[fields.name][0])
            .add('1', 'weeks')
            .format(fields.valueFormat ? fields.valueFormat : 'GGGG-WW[周]');
          this.search();
        } else if (fields.picker === 'quarter') {
          this.model[fields.name][0] = moment(this.model[fields.name][0])
            .add('1', 'quarters')
            .format(fields.valueFormat ? fields.valueFormat : '');
          this.search();
        } else if (fields.picker === 'year') {
          this.model[fields.name][0] = moment(this.model[fields.name][0])
            .add('1', 'years')
            .format(fields.valueFormat ? fields.valueFormat : 'YYYY');
          this.search();
        }
      }
    },
    reduceRangeAfter(fields) {
      if (this.model[fields.name]) {
        if (!fields.picker || fields.picker === 'date') {
          this.model[fields.name][1] = moment(this.model[fields.name][1])
            .subtract('1', 'days')
            .format(fields.valueFormat ? fields.valueFormat : 'YYYY-MM-DD');
          this.search();
        } else if (fields.picker === 'month') {
          this.model[fields.name][1] = moment(this.model[fields.name][1])
            .subtract('1', 'months')
            .format(fields.valueFormat ? fields.valueFormat : 'YYYY-MM');
          this.search();
        } else if (fields.picker === 'week') {
          this.model[fields.name][1] = moment(this.model[fields.name][1])
            .subtract('1', 'weeks')
            .format(fields.valueFormat ? fields.valueFormat : 'GGGG-WW[周]');
          this.search();
        } else if (fields.picker === 'quarter') {
          this.model[fields.name][1] = moment(this.model[fields.name][1])
            .subtract('1', 'quarters')
            .format(fields.valueFormat ? fields.valueFormat : '');
          this.search();
        } else if (fields.picker === 'year') {
          this.model[fields.name][1] = moment(this.model[fields.name][1])
            .subtract('1', 'years')
            .format(fields.valueFormat ? fields.valueFormat : 'YYYY');
          this.search();
        }
      }
    },
    addRangeAfter(fields) {
      if (this.model[fields.name]) {
        if (!fields.picker || fields.picker === 'date') {
          this.model[fields.name][1] = moment(this.model[fields.name][1])
            .add('1', 'days')
            .format(fields.valueFormat ? fields.valueFormat : 'YYYY-MM-DD');
          this.search();
        } else if (fields.picker === 'month') {
          this.model[fields.name][1] = moment(this.model[fields.name][1])
            .add('1', 'months')
            .format(fields.valueFormat ? fields.valueFormat : 'YYYY-MM');
          this.search();
        } else if (fields.picker === 'week') {
          this.model[fields.name][1] = moment(this.model[fields.name][1])
            .add('1', 'weeks')
            .format(fields.valueFormat ? fields.valueFormat : 'GGGG-WW[周]');
          this.search();
        } else if (fields.picker === 'quarter') {
          this.model[fields.name][1] = moment(this.model[fields.name][1])
            .add('1', 'quarters')
            .format(fields.valueFormat ? fields.valueFormat : '');
          this.search();
        } else if (fields.picker === 'year') {
          this.model[fields.name][1] = moment(this.model[fields.name][1])
            .add('1', 'years')
            .format(fields.valueFormat ? fields.valueFormat : 'YYYY');
          this.search();
        }
      }
    },
    isShow(name) {
      let is = false;
      if (this.form?.sideSearch && this.form?.sideSearch.length > 0) {
        this.form?.sideSearch.forEach(item => {
          if (item.name == name) {
            is = true;
          }
        });
      }
      return is;
    },
    handleShowGeneralFilter() {
      this.$emit('showGeneralFilter', { is_show: true });
    },
  },
  created() {
    if (this.form.watch) {
      for (const k in this.form.watch) {
        watch(
          () => this.model[k],
          () => {
            this.form.watch[k](this.model, this.form);
          },
        );
      }
    }
  },
};
</script>
<style scoped lang="less">
:deep(.ant-select-selection-placeholder) {
  overflow: hidden;
  width: 100%;
}
</style>
